/**
 * BreadcrumbClassWarnings — TICKET-1318. Classifier self-check warnings for one voice
 * note (classification_json._warnings), shown above the suggested actions. Today the
 * only code is bundle_count_mismatch: the note's body named more packages than bundle
 * suggestions came out (Noona 2026-10-19: 3 named, 2 suggested).
 */
import { AlertTriangle } from 'lucide-react';
import { useT } from '../../../lib/i18n/I18nContext';

export default function BreadcrumbClassWarnings({ warnings }) {
  const { t } = useT();
  const list = Array.isArray(warnings) ? warnings.filter((w) => w?.code === 'bundle_count_mismatch') : [];
  if (!list.length) return null;
  const w = list[0];
  return (
    <div
      data-testid="breadcrumb-class-warning"
      role="status"
      style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '6px 10px', margin: '6px 0', borderRadius: 8, background: 'var(--warn-tint)', color: 'var(--warn)', fontSize: 12, lineHeight: 1.4 }}
    >
      <AlertTriangle size={14} aria-hidden="true" style={{ flexShrink: 0 }} />
      <span>{t('breadcrumbCard.bundleCountMismatch', { named: w.named, emitted: w.emitted })}</span>
    </div>
  );
}
